<script>
import appConfig from "@/app.config";
import CampaignTable from "@/components/campaign/crud/Table";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "لیست کمپین ها",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    CampaignTable,
  },
  data() {
    return {
      title: "لیست کمپین ها",
      items: [
        {
          text: "مدیریت کمپین ها",
        },
        {
          text: "لیست کمپین ها",
          to: { name: "campaigns" },
        },
      ],
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <CampaignTable />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
